import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
	clearAdvanceFilter,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../../../../store/action/advanceFilter';
import { formatFilterName, getFiltersParams, getUniqueFilterOptions } from '../../../../../helper';
import { toast } from 'react-toastify';
import {
	changeCustomerStatus,
	deleteCustomer,
	getCustomerList,
} from '../../../../../services/customers';
import { hasPermission } from '../../../../../utils/controller';

export default function useCustomer() {
	const [bulkAction, setBulkAction] = useState([]);
	const [isMarkAsStatus, setIsMarkAsStatus] = useState({
		isModelOpen: false,
		isStatus: null,
	});
	const [searchParams, setSearchParams] = useSearchParams();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [selectedCustomerListForDelete, setSelectedCustomerListForDelete] = useState([]);
	const [deselectRows, setDeselectRows] = useState(null);
	const [headerDropDown, setHeaderDropDown] = useState('All Customers');
	const [sortDirection, setSortDirection] = useState({ id: 'asc' });
	const suburl = localStorage.getItem('suburl');
	const dispatch = useDispatch();
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		orderBy: advanceFilterOrderby,
		sortBy: advanceFilterSortBy,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);
	const [customersList, setCustomers] = useState({
		data: [],
		totalPages: 0,
		currentPage: 1,
	});
	// Restore list state (page, page_size, sorting) from sessionStorage if available
	const [customersParams, setCustomersParams] = useState(() => {
		const savedState = sessionStorage.getItem('customersParams');
		if (savedState) {
			sessionStorage.removeItem('customersParams');
			return JSON.parse(savedState);
		}
		return {
			page: Number(searchParams.get('page')) || 1,
			page_size: Number(searchParams.get('page_size')) || 20,
			order_by: searchParams.get('order_by') || 'created_at',
			sort_by: searchParams.get('sort_by') || 'desc',
			filters: {},
		};
	});
	const [isLoading, setLoading] = useState(false);
	const [isLoader, setLoader] = useState(false);
	const navigate = useNavigate();
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};
	async function handleOnFocusSelectedFilterInput(key) {
		let selectInputData = [];

		if (key !== 'status') {
			const { customers } = await getCustomerList({ ...customersParams, page_size: 1000 });

			selectInputData = customers
				?.filter((customer) => customer[key])
				?.map((customer) => ({
					key: customer[key],
					value: customer[key],
				}));
		} else {
			selectInputData = [
				{ key: 'Active Customers', value: 'Active Customers' },
				{ key: 'Inactive Customers', value: 'Inactive Customers' },
				{ key: 'Draft Customers', value: 'Draft Customers' },
				{ key: 'Duplicate Customers', value: 'Duplicate Customers' },
			];
		}
		const uniqueData = getUniqueFilterOptions(selectInputData);
		dispatch(setSelectedInputData({ key, data: uniqueData }));
		return uniqueData;
	}

	async function handleApplyFilters(params) {
		try {
			if (Object.keys(params).length === 0) {
				getCustomers();
				return;
			}

			if (params.status) {
				setHeaderDropDown(params.status);
			}

			const updatedParams = { ...params };

			if (updatedParams.status === 'Active Customers') {
				updatedParams.status = 1;
			}

			if (updatedParams.status === 'Inactive Customers') {
				updatedParams.status = 2;
			}

			if (updatedParams.status === 'Draft Customers') {
				updatedParams.status = 0;
			}

			if (updatedParams.status === 'Duplicate Customers') {
				updatedParams.status = 4;
			}

			var { customers, total_pages } = await getCustomerList({
				order_by: advanceFilterOrderby,
				sort_by: advanceFilterSortBy,
				page: advanceFilterPage,
				page_size: advanceFilterPageSize,
				filters: updatedParams,
			});
			const customerLists = mappedTableData(customers);
			setBulkAction([]);
			// Set active page for filtered customer list
			setCustomers((prev) => ({
				...prev,
				data: customerLists,
				totalPages: total_pages,
				currentPage: advanceFilterPage || 1,
			}));
			dispatch(setAdvanceFilterTotalPage({ totalPages: total_pages }));
			setIsAdvanceFilterOpen(false);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong! Try again.');
		}
	}


	const onRowClick = (id) => {
		if (id && hasPermission('sales.customers.view', user?.role?.role_permissions)) {
			sessionStorage.setItem('customersParams', JSON.stringify(customersParams));
			navigate(`/user/${suburl}/customers-details/${id}`);
		}
	};

	const FilterDatalist = (param, value, dropDownData) => {
		if (dropDownData === 'All Customers') {
			handleClearAllFilters();
			return;
		}
		setHeaderDropDown(dropDownData);

		const selectInputData = [
			{ key: 'Active Customers', value: 'Active Customers' },
			{ key: 'Inactive Customers', value: 'Inactive Customers' },
			{ key: 'Draft Customers', value: 'Draft Customers' },
			{ key: 'Duplicate Customers', value: 'Duplicate Customers' },
		];
		const hasStatus = selectedInputs.some((input) => input.key === 'status');
		const updatedSelectedInput = hasStatus
			? selectedInputs.map((input) => {
					if (input.key === 'status') {
						return {
							...input,
							value: dropDownData,
							data: selectInputData,
						};
					}
					return input;
			  })
			: [
					...selectedInputs,
					{
						key: 'status',
						label: 'Status',
						value: dropDownData,
						data: selectInputData,
					},
			  ];
		dispatch(setSelectedInput({ key: 'status', label: 'Status' }));
		dispatch(setSelectedInputValue({ key: 'status', value: dropDownData }));
		dispatch(setSelectedInputData({ key: 'status', data: selectInputData }));
		dispatch(setAdvanceFilter({ selectedInputs: updatedSelectedInput, isAdvanceFilterApplied: true }));
		const params = getFiltersParams(updatedSelectedInput);
		handleApplyFilters(params);
	};

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.sort_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.sort_by]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ order_by: newDirection, sort_by: param.sort_by }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setCustomersParams((prev) => ({
				...prev,
				order_by: newDirection,
				sort_by: param.sort_by,
			}));
		}
	};

	const handlePageChange = (page) => {
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilterPage({ page }));
		}
		setCustomersParams((prev) => ({
			...prev,
			page,
		}));
	};

	const getModalContent = () => {
		return (
			<div>
				<p
					style={{ fontWeight: '600' }}
					className="ConfirmationText"
				>
					Are you sure you want to mark these {bulkAction.length} customers as{' '}
					{isMarkAsStatus.isStatus === 1 ? 'Active' : 'Inactive'}?
				</p>
				<div
					style={{
						padding: '0px 10px',
					}}
				>
					{customersList.data
						.filter((customer) => bulkAction.includes(customer.id))
						.map((customer, index) => (
							<p key={customer.id}>
								{index + 1}. {JSON.parse(customer['name'])['name']}
							</p>
						))}
				</div>
			</div>
		);
	};

	async function handleBulkDelete() {
		try {
			if (bulkAction.length === 0) {
				toast.error('Please select customer!');
				return;
			}
			var body = JSON.stringify({
				ids: bulkAction,
			});
			await deleteCustomer(body);
			toast.success('Customers Deleted Successfully.');
			setIsDeleteModalOpen(false);
			setBulkAction([]);
			deselectRows && deselectRows();
			getCustomers();
		} catch (error) {
			toast.error(error?.message || 'Something went wrong');
		}
	}

	function handleOpenBulkDeleteCustomerModal() {
		const selectedVendorsList = customersList.data?.reduce((acc, item) => {
			if (bulkAction.includes(item.id)) {
				acc.push(JSON.parse(item['name'])['name']);
				return acc;
			}
			return acc;
		}, []);
		setSelectedCustomerListForDelete(selectedVendorsList);
		setIsDeleteModalOpen(true);
	}

	const triggerConfirmationModal = (status) => {
		setIsMarkAsStatus((prev) => ({
			isModelOpen: true,
			isStatus: status,
		}));
	};

	async function handleIsActiveStatus(status) {
		try {
			const formbody = {
				ids: bulkAction,
				status: status,
			};
			setLoader(true);
			await changeCustomerStatus(formbody);
			toast.success('Status Changes Successfully');
			setCustomersParams((prev) => ({
				...prev,
				filterBy: 'status',
				filterValue: headerDropDown === 'All Customers' ? null : status ? 0 : 1,
			}));
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setLoader(false);
		}
	}

	const closeModal = () => {
		setIsMarkAsStatus((prev) => ({
			isModelOpen: false,
			isStatus: null,
		}));
	};

	const getCustomers = async (params = customersParams) => {
		setLoading(true);
		var { customers, total_pages, page } = await getCustomerList(params);
		const customerLists = mappedTableData(customers);
		setBulkAction([]);
		setCustomers((prev) => ({
			...prev,
			data: customerLists,
			totalPages: total_pages,
			currentPage: page,
		}));
		setLoading(false);
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.id,
				name:
					JSON.stringify({
						name: ele?.name,
						status: ele?.status,
						type: ele?.type,
					}) || 'N/A',
				EMAIL: ele?.email || 'N/A',
				MOBILE: ele?.mobile || 'N/A',
				RECEIVABLES: Number(ele?.receivables || 0).toFixed(2),
				'UNUSED CREDITS': Number(ele?.unused_credit_amount || 0).toFixed(2),
			};
		});
	}

	const setHeaderDropdownStatus = (filters) => {
		const statusMap = {
			0: 'Draft Customers',
			1: 'Active Customers',
			2: 'Inactive Customers',
			4: 'Duplicate Customers',
		};
		if (filters.status !== undefined) {
			setHeaderDropDown(statusMap[filters.status]);
		}
	};

	const setFilterFromUrl = () => {
		const filters = {};
		searchParams.forEach((value, key) => {
			if (key !== 'page' && key !== 'page_size' && key !== 'order_by' && key !== 'sort_by') {
				filters[key] = value;
			}
		});
		setSortDirection({
			[searchParams.get('sort_by')]: searchParams.get('order_by') || '',
		});
		setHeaderDropdownStatus(filters);
		Object.entries(filters).forEach(([key, value]) => {
			const statusValueMap = {
				0: 'Draft Customers',
				1: 'Active Customers',
				2: 'Inactive Customers',
				4: 'Duplicate Customers',
			};
			const fieldValue = key === 'status' ? statusValueMap[value] : value;
			dispatch(
				setSelectedInput({
					key: key,
					label: key === 'name' ? 'Customer Name' : formatFilterName(key),
				}),
			);
			dispatch(
				setSelectedInputValue({
					key: key,
					value: fieldValue,
				}),
			);
			handleOnFocusSelectedFilterInput(key);
		});
		if (Object.keys(filters).length > 0) {
			dispatch(
				setAdvanceFilter({
					isAdvanceFilterApplied: true,
					page: Number(searchParams.get('page')) || customersParams.page || 1,
					pageSize: Number(searchParams.get('page_size')) || customersParams.page_size || 20,
					order_by: searchParams.get('order_by') || customersParams.order_by || 'created_at',
					sort_by: searchParams.get('sort_by') || customersParams.sort_by || 'desc',
				}),
			);
		} else {
			setCustomersParams((prev) => ({
				...prev,
				filters,
			}));
		}
	};

	useEffect(() => {
		setFilterFromUrl();
	}, []);

	function getParams(params) {
		const status = params.status;
		if (!status) return params;
		setHeaderDropDown(status);
		const statusMap = {
			'Draft Customers': 0,
			'Active Customers': 1,
			'Inactive Customers': 2,
			'Duplicate Customers': 4,
		};

		return {
			...params,
			status: statusMap[status],
		};
	}

	const setUrlSearchParams = () => {
		const url = new URLSearchParams();
		// Normal params
		url.set('page', isAdvanceFilterApplied ? advanceFilterPage : customersParams.page);
		url.set(
			'page_size',
			isAdvanceFilterApplied ? advanceFilterPageSize : customersParams.page_size,
		);
		url.set('order_by', isAdvanceFilterApplied ? advanceFilterOrderby : customersParams.order_by);
		url.set('sort_by', isAdvanceFilterApplied ? advanceFilterSortBy : customersParams.sort_by);
		if (selectedInputs.length > 0) {
			const filters = getParams(getFiltersParams(selectedInputs));
			Object.entries(filters).forEach(([key, value]) => {
				if (value !== undefined && value !== null && value !== '') {
					url.set(key, value);
				}
			});
		} else {
			Object.entries(customersParams.filters).forEach(([key, value]) => {
				url.set(key, value);
			});
		}
		setSearchParams(url);
	};

	useEffect(() => {
		setUrlSearchParams();
	}, [
		customersParams,
		selectedInputs,
		advanceFilterPage,
		advanceFilterPageSize,
		advanceFilterOrderby,
		advanceFilterSortBy,
		isAdvanceFilterApplied,
	]);

	// Fetch customer list when params, filter, or pagination changes
	useEffect(() => {
		const stockFilterKeys = ['customer_name', 'email', 'mobile', 'status'];
		const hasStockFilter = stockFilterKeys.some((key) => searchParams.has(key));
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			if (!hasStockFilter) {
				getCustomers();
			}
		}
	}, [
		customersParams,
		isAdvanceFilterApplied,
		advanceFilterPage,
		advanceFilterPageSize,
		advanceFilterOrderby,
		advanceFilterSortBy,
	]);

	const handleClearAllFilters = () => {
		dispatch(clearAdvanceFilter());
		setHeaderDropDown('All Customers');
		setSearchParams({});
		const cleanParams = {
			...customersParams,
			page: 1,
			filters: {},
		};
		setCustomersParams(cleanParams);
		getCustomers(cleanParams);
	};

	return {
		user,
		customersList,
		suburl,
		handlePageChange,
		onRowClick,
		handleDeselectAll,
		FilterDatalist,
		sortDataList,
		handleOnFocusSelectedFilterInput,
		handleApplyFilters,
		setIsAdvanceFilterOpen,
		isAdvanceFilterOpen,
		isAdvanceFilterApplied,
		selectedInputs,
		setBulkAction,
		bulkAction,
		triggerConfirmationModal,
		deselectRows,
		isLoading,
		isLoader,
		setHeaderDropDown,
		headerDropDown,
		dispatch,
		getModalContent,
		closeModal,
		isMarkAsStatus,
		handleIsActiveStatus,
		handleOpenBulkDeleteCustomerModal,
		isDeleteModalOpen,
		setIsDeleteModalOpen,
		selectedCustomerListForDelete,
		handleBulkDelete,
		sortDirection,
		advanceFilterPage,
		advanceFilterPageSize,
		advanceFilterTotalPages,
		customersParams,
		setCustomersParams,
		handleClearAllFilters
	};
}
